export default __webpack_public_path__ + "static/media/Presentatie duurzame ontwikkeling en educatie voor duurzame ontwikkeling.647b3e10.zip";